<template>
    <vs-table :data="data">
          <template slot="thead">
            <th class="qb-sticky" :style="{textAlign:'left'}">{{ $t('department') }}</th>
            <th class="qb-sticky" :style="{textAlign:'center'}">HCount</th>
            <th class="qb-sticky" :style="{textAlign:'center'}">RegHours</th>
            <th class="qb-sticky" :style="{textAlign:'center'}">OTHours</th>
            <th class="qb-sticky" :style="{textAlign:'center'}">MXN OT</th>
            <th class="qb-sticky" :style="{textAlign:'center'}">USD OT</th>
            <th class="qb-sticky" :style="{textAlign:'center'}">MXN</th>
            <th class="qb-sticky" :style="{textAlign:'center'}">USD est.</th>
            <th class="qb-sticky" :style="{textAlign:'center'}">USD/HR</th>
            <th class="qb-sticky"  :style="{textAlign:'right'}">Total</th>
          </template>

          <template slot-scope="{ data }">
            <vs-tr :key="i" v-for="(tr, i) in data">
              <vs-td :style="{ width: '35vw' }" class="text-left">{{tr.DepartmentName}}</vs-td>
              <vs-td :style="{ width: '10vw' }" class="text-center">{{ tr.HeadCount }}</vs-td>
              <vs-td :style="{ width: '10vw' }" class="text-center">{{ tr.RegularHours }}</vs-td>
              <vs-td :style="{ width: '10vw' }" class="text-center">{{ tr.OvertimeHours }}</vs-td>
              <vs-td :style="{ width: '10vw' }" class="text-center">{{ tr.OTHoursIncome }}</vs-td>
              <vs-td :style="{ width: '10vw' }" class="text-center">{{ tr.USDOT }}</vs-td>
              <vs-td :style="{ width: '10vw' }" class="text-center">{{ tr.TotalPayrollMXP }}</vs-td>
              <vs-td :style="{ width: '10vw' }" class="text-center">{{ tr.TotalPayrollUSD }}</vs-td>
              <vs-td :style="{ width: '10vw' }" class="text-center">{{ tr.USD_HR }}</vs-td>
              <vs-td :style="{ width: '10vw' }" class="text-right">${{ formatNumber(tr.Total,2) }}</vs-td>
            </vs-tr>
            <vs-tr v-show="data.length == 0">
              <vs-td :colspan="10" class="text-center">
                <p>{{ loadingMessage }}</p>
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>
</template>

<script>


export default {

    props:{
        data: {
            type: Array,
            default: () => ({})
        },
        loadingMessage:{
            type:String,
            default:'Cargando...'
        }
    }
}
</script>